import { useQueryClient } from "@tanstack/react-query";
import { FormEvent, useState } from "react";
import { Button, Form, FormGroup, Input, Modal } from "reactstrap";
import API from "../../../api/api/API";
import AppSpinner from "../../../elements/AppSpinner";
import { Tenant } from "../../../types/GlobalInterfaces";

interface Props {
  open: boolean;
  onClose: () => void;
  cloud: any;
}

const RenameCloudModal = ({ open, onClose, cloud }: Props) => {
  const [name, setName] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const queryClient = useQueryClient();

  return (
    <Modal className="modal-dialog-centered" isOpen={open} toggle={onClose}>
      <div className="modal-header">
        <h5 className="modal-title" id="exampleModalLabel">
          Rename Cloud
        </h5>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={onClose}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <Form onSubmit={renameCloud}>
        <div className="modal-body">
          <FormGroup>
            <h5>New Name</h5>
            <Input
              placeholder="Enter a new name"
              type="text"
              name="newName"
              value={name}
              onChange={(e) => setName(e.target.value)}
            ></Input>
          </FormGroup>
        </div>
        <div className="modal-footer">
          <Button
            color="secondary"
            data-dismiss="modal"
            type="button"
            onClick={onClose}
          >
            Close
          </Button>
          <Button
            color="primary"
            type="submit"
            disabled={!name || submitting}
            style={{ width: 100 }}
          >
            {submitting ? (
              <AppSpinner style={{ height: 20, width: 20 }} color="white" />
            ) : (
              <>Submit</>
            )}
          </Button>
        </div>
      </Form>
    </Modal>
  );

  function renameCloud(e: FormEvent) {
    e.preventDefault();
    setSubmitting(true);

    API.updateCloud(cloud.id, { Name: name })
      .then(
        (data) => {
          const updatedTenant = data.data.data.tenant;
          queryClient.invalidateQueries({
            queryKey: ["cloud", cloud.id]
          });

          queryClient.setQueryData<Tenant[]>(["allClouds"], (prev) => {
            if (!Array.isArray(prev)) return prev;

            return prev.map((c) => (c.id === cloud.id ? updatedTenant : c));
          });

          onClose();
        },
        (err) => {
          console.error(err);
        }
      )
      .finally(() => setSubmitting(false));
  }
};

export default RenameCloudModal;
